import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Local } from '../models/local';
import { Result } from '../models/result';

@Injectable({ providedIn: 'root' })
export class LocalService {
  apiUrl = environment.urlControlCenterApi + 'local';

  constructor(private http: HttpClient) {}

  getById(id: number) {
    return this.http.get<Result<Local>>(`${this.apiUrl}/${id}`);
  }

  getAll() {
    return this.http.get<Result<Local[]>>(`${this.apiUrl}`);
  }

  insert(data: Local) {
    return this.http.post<Result<Local>>(this.apiUrl, data);
  }

  update(data: Local) {
    return this.http.put<Result<Local>>(`${this.apiUrl}`, data);
  }

  delete(id: number) {
    return this.http.delete<Result<boolean>>(`${this.apiUrl}/${id}`);
  }
}
